import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  computed,
  inject
} from '@angular/core';
import { ErrorService } from '@services/error.service';
import { NotificationService } from '@services/notification.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationComponent {
  @Output() close = new EventEmitter();
  private readonly notificationService = inject(NotificationService);
  private readonly errorService = inject(ErrorService);
  readonly unexpectedError$ = this.errorService.unexpectedError$;
  protected showDetails = this.notificationService.showDetail;

  protected readonly notifications = this.notificationService.notifications;

  protected readonly unReadMsgCount = this.notificationService.unReadMsgCount;

  protected readonly notification = this.notificationService.selectedNotification;
  protected isWebview: boolean = false;
  showDetailNoti(id: number) {
    this.errorService.closeError();
    this.notificationService.setShowDetail(true);
    this.notificationService.getDetail(id);
    this.notificationService.markAsCheckNoti(id).subscribe();
  }

  closeDetailModal() {
    this.notificationService.setShowDetail(false);
    this.initData();
  }

  ngOnInit() {
    const userAgent = navigator.userAgent.toLowerCase();
    let safari = /safari/.test(userAgent);
    let ios = /iphone|ipod|ipad/.test(userAgent);
    if (userAgent.indexOf('wv') > -1 || userAgent.indexOf('webview') > -1 || (!safari && ios)) {
      this.isWebview = true;
    }
    this.initData();
  }

  protected readonly setShowDetail = (value: boolean) => {
    this.notificationService.setShowDetail(value);
  };
  initData() {
    this.notificationService.initData();
  }

  getFileType(url: string) {
    const fileName = url.split('.').pop();
    return fileName;
  }

  getFileName(url: any) {
    const fileName = url.split('/').pop();
    return fileName;
  }

  download(url: any) {
    window.location.href = url;
  }

  closeModal() {
    this.errorService.closeError();
    this.notificationService.closePopup();
    this.close.emit();
  }
}
